import { BaseAPI } from "@utils";

class ConstructionApi extends BaseAPI<any> {}

export const constructionApi = new ConstructionApi("/api/v1/construction");
